export default class DragMoveService {
    constructor() {
        this.isEntityDragActive = false;
        this.modelPageY = false;
    }

    scrollEntities(container, pageY, action) {
        if (pageY === this.modelPageY) { // if the mouse is in the same place keep scrolling
            if (action === 'scrollDown') {
                // eslint-disable-next-line no-param-reassign
                container.scrollTop += 10; // scroll down 20px
            } else if (action === 'scrollUp') {
                // eslint-disable-next-line no-param-reassign
                container.scrollTop -= 10; // scroll up 20px
            }
            // keep scrolling if the mouse is not moving
            if (this.isEntityDragActive) {
                // pass the function by name with its binded params without running the function
                setTimeout(() => {
                    this.scrollEntities(container, pageY, action);
                }, 20);
            }
        }
    }

    // while dragging - scroll if the user gets near the top/bottom of the entities list
    dragMove(eventObj, container) {
        this.modelPageY = eventObj.clientY; // mouse distance from the top of the page
        if (eventObj) {
            const pageY = this.modelPageY;
            // distance from the top of the entities list
            const distanceFromTopOfContainer = pageY - container.getBoundingClientRect().top;

            // if the mouse's distance from the top of the entities list is 30px or less
            if (distanceFromTopOfContainer < 60) {
                this.scrollEntities(container, pageY, 'scrollUp');
                // if the mouse's distance from the bottom of the entities list is 30px or less
            } else if (distanceFromTopOfContainer > container.clientHeight - 60) {
                this.scrollEntities(container, pageY, 'scrollDown');
            }
        }
    }
}
